import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {DESTINATION_DATA} from 'destination/destination-prop-types';
import moment from 'moment';
import IconInfo from '@spothero/icons/info';
import TextButton from '@spothero/ui/text-button';
import withConfig from 'config/withConfig';
import EventSchema from './EventSchema';

class EventListItem extends Component {
    static propTypes = {
        event: PropTypes.object.isRequired,
        destination: PropTypes.shape(DESTINATION_DATA).isRequired,
        city: PropTypes.object.isRequired,
        onClick: PropTypes.func,
        siteUrl: PropTypes.string.isRequired,
        showFindParking: PropTypes.bool,
        showVenue: PropTypes.bool,
        showYear: PropTypes.bool,
        onShowInfoClick: PropTypes.func,
    };
    static defaultProps = {
        showFindParking: true,
    };

    constructor(props) {
        super(props);

        const {
            event: {starts, ends},
            city: {timezone},
        } = props;

        this._starts = moment.tz(starts, timezone);
        this._ends = moment.tz(ends, timezone);
        this._startsISO = this._starts.toISOString();
        this._endsISO = this._ends.toISOString();
    }

    _onClick = evt => {
        const {event, onClick} = this.props;

        if (onClick) {
            onClick(event);
        }
    };

    render() {
        const {
            event: {
                title,
                search_url: eventUrl,
                meta_description: eventMetaDescription,
            },
            destination,
            city,
            siteUrl,
            showFindParking,
            showVenue,
            showYear,
            onShowInfoClick,
        } = this.props;
        const startsDateFormat = this._starts.isSame(moment(), 'day')
            ? '[Today]'
            : `ddd, ${showYear ? 'MMM D YYYY' : 'M/D'}`;

        return (
            <div
                className="EventListItem"
                itemScope
                itemType="http://schema.org/Event"
                onClick={onShowInfoClick ? null : this._onClick}
            >
                <div className="EventListItem-date">
                    <span>{this._starts.format('MMM')}</span>
                    <span>{this._starts.format('DD')}</span>
                </div>
                <div className="EventListItem-details">
                    <p itemProp="name">
                        {title}{' '}
                        {onShowInfoClick && destination.description && (
                            <TextButton
                                className="EventListItem-info-link"
                                onClick={onShowInfoClick}
                            >
                                <IconInfo />
                            </TextButton>
                        )}
                    </p>
                    <div className="EventListItem-bottom">
                        <p>
                            {showVenue && `${destination.title} · `}
                            {this._starts.format(
                                `${startsDateFormat} [at] h:mm A`
                            )}
                        </p>
                        {showFindParking && <p>Find Parking</p>}
                    </div>
                </div>
                <EventSchema
                    url={eventUrl}
                    metaName={title}
                    metaDescription={eventMetaDescription}
                    starts={this._startsISO}
                    ends={this._endsISO}
                    destination={destination}
                    city={city}
                />
                <span
                    itemScope
                    itemProp="offers"
                    itemType="http://schema.org/AggregateOffer"
                >
                    <meta itemProp="url" content={`${siteUrl}/${eventUrl}`} />
                </span>
            </div>
        );
    }
}

export default withConfig(['siteUrl'])(EventListItem);
